import React, { useEffect, useState } from 'react';

import '../assets/scss/about-header.scss';
import RatingStore from '../store/RatingStore';
import background from '../assets/images/background.jpg';
import { observer } from 'mobx-react';

const AboutHeader: React.FC = observer(() => {
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!fetched) {
      RatingStore.fetchPrize();
      RatingStore.fetchDayPrize();
      setFetched(true);
    }
  }, [fetched, setFetched]);

  return (
    <>
      <div className="about-header">
        <div className="container" style={{ maxWidth: '1600px'}}>
          <div className="about-header_inner">
            <div className="about-header_info">
              <div className="about-header_info-icon" />
              <div className="about-header_info-content">
                <h3 className="about-header_info-title">Сквозной турнир по игре<br />Assetto Corsa</h3>
                <p className="about-header_info-description">Подробности можно узнать у <span style={{ color: 'red' }}><b>Администратора</b></span>.</p>
                <p className="about-header_info-description">Или по телефону: <b>+7 (3953) 200-175</b></p>
              </div>
            </div>
            <div className="divider" />
            <div className="about-header_info prize-fund">
              <div className="about-header_info-content">
                <h3 className="about-header_info-title">Текущий призовой фонд</h3>
                <p className="about-header_info-description"><span style={{ color: 'red' }}><b>5%</b></span> от стоимости игры, участвующей в турнире,<br></br> идут в призовой фонд.</p>
              </div>
              <div className="about-header_info-prize-fund">
                <h1 className="about-header_info-amount">{RatingStore.prize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽</h1>
                <h3 className="about-header_info-today">{RatingStore.dayPrize > 0 ? `+${(15).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽` : <></>}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default AboutHeader;